import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';

/**
 * Bitácora de inventario: una fila por pieza y por movimiento.
 * De consulta en el front; las escrituras las hace el motor de
 * movimientos del API dentro de cada flujo (recepción, etiquetado, etc.).
 */
@Injectable({ providedIn: 'root' })
export class InventoryMovementsService extends ApiBaseService<any> {
  constructor() {
    super('inventorymovements');
  }
}
